// router.js

import { createRouter, createWebHistory } from 'vue-router';


import ContactComponent from '@/components/ContactList.vue';
import HelloWorldComponent from '@/components/HelloWorld.vue';
import TmNetComponent from '@/components/TmNet.vue';
import listMyCallComponent from '@/components/listMyCall.vue';

const routes = [

  {
    path: '/CList/:projectKey',
    name: 'CList',
    component: ContactComponent
  },
  {
    path: '/HelloWorld',
    name: 'HelloWorld',
    component: HelloWorldComponent
  },
  {
    path: '/TmNet',
    name: 'TmNet',
    component: TmNetComponent
  },
  {
    path: '/listMyCall',
    name: 'listMyCall',
    component: listMyCallComponent
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
